const { Box } = require("@mui/material");
const { formatNumber } = require("utiles/url");

const TotalAmount = ({ amount }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-end",
        flexDirection: "column",
        p: 1,
        gap: 1,
        m: 1,
        bgcolor: "background.paper",
        borderRadius: 1,
      }}
    >
      <div
        style={{
          marginRight: "35px",
          fontWeight: "bold",
          fontSize: "15px",
        }}
      >
        Total Amount: {formatNumber(amount)}
      </div>
    </Box>
  );
};
export default TotalAmount;
